<div class="p-grid table-demo manage-product-section">
    <div class="p-col-12">
        <div class="card  p-pt-3">
            <p-toast key="toastmsg"></p-toast>
            <div class="col-md-12 d-flex details-header">
                <div class="user-name">
                    <h3>Credit Note</h3>
                </div>
            </div>
            
            <p-toolbar styleClass="p-mb-4">
                <ng-template pTemplate="left">
                    <button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2"
                        icon="pi pi-filter-slash" (click)="clear()
					"></button>
                </ng-template>
               
              
                <ng-template pTemplate="right">
                    <button pButton pRipple label="Download Excel" icon="pi pi-file-excel" (click)="exportExcel()"
                        class="p-button-help mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                        <button pButton pRipple label="Download Zip" icon="pi pi-file-excel" (click)="generateAndDownloadZip()"
                        class="p-button-help mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                </ng-template>
            </p-toolbar>
           
            <div class="card">
                <div class="p-fluid p-formgrid p-grid align-items-end">
                    <div class="p-field p-col-2">
                        <label for="searchfield">Select Field</label>
                        <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                            placeholder="Select Field" optionLabel="label"></p-dropdown>
                    </div>
                    <div class="p-field p-col-2">
                        <label for="startdt">Start Date</label>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
                            [showIcon]="true"></p-calendar>
                    </div>
                    <div class="p-field p-col-2">
                        <label for="enddt">End Date</label>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                            [showIcon]="true"></p-calendar>
                    </div>
                    <div class="p-field p-col-1">
                        <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-"
                            (click)="loadWalletHistory($event)"></button>
                    </div>
                   
                </div>
            </div>


            <p-table class="p2-table-columns show-columns" #dt [value]="walletlist" [paginator]="true" [rows]="10"
                [lazy]="true" (onLazyLoad)="loadWalletHistory($event)" [totalRecords]="totalRecords" [loading]="loading"
                [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="id" [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Transaction ID
                                <p-sortIcon field="id"></p-sortIcon>
                            </div>
                        </th>
                        <th pSortableColumn="id" [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                User Name
                                <p-sortIcon field="id"></p-sortIcon>
                            </div>
                        </th>
                        <th [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">Description</div>
                        </th>
                        <th pSortableColumn="amount" [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Amount
                                <p-sortIcon field="amount"></p-sortIcon>
                            </div>
                        </th>
                        <th pSortableColumn="created_at" [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Created Date
                                <p-sortIcon field="created_at"></p-sortIcon>
                            </div>
                        </th>
                        <th [style]="{'width':'100px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Action
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th [ngSwitch]="id">
                            <input pInputText type="text"
                                (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'id', 'contains')"
                                [value]="dt.filters['id'] ? dt.filters['id'].value : ''" />
                        </th>
                        <th [ngSwitch]="userName">
                            <input pInputText type="text"
                                (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                                [value]="dt.filters['userName'] ? dt.filters['userName'].value : ''" />
                        </th>
                        
                        <th [ngSwitch]="description" class="statusTd">
                            <p-dropdown appendTo="body" #pDropDownId [options]="description"
                              (onChange)="setDownloadFlag(); dt.filter($event.value, 'description', 'equals')" placeholder="Select Description"
                              [showClear]="true">
                              <ng-template let-option pTemplate="item">
                                <span [class]="'customer-badge description-' + option.value">{{option.label}}</span>
                              </ng-template>
                            </p-dropdown>
                          </th>
                        <th [ngSwitch]="amount" class="">
                            <input pInputText type="text"
                                (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'amount', 'contains')"
                                [value]="dt.filters['amount'] ? dt.filters['amount'].value : ''" />
                        </th>
                        <th [ngSwitch]="created_at" class="">
                        </th>
                        <th class="">
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-userwallet>
                    <tr class="p-selectable-row">
                        <td>
                            {{userwallet.id}}
                        </td>
                        <td>
                            {{userwallet.userData[0]?.fullName}}
                        </td>
                        <td>
                            {{userwallet.description}}
                        </td>
                        <td *ngIf="userwallet.action=='ADD'">
                            <i class='pi pi-plus'></i> {{userwallet.amount}} {{userwallet.wallettype | lowercase }}
                        </td>
                        <td *ngIf="userwallet.action=='SUBTRACT'">
                            <i class='pi pi-minus'></i> {{userwallet.amount}} {{userwallet.wallettype | lowercase }}
                        </td>
                        <td>
                            {{userwallet.created_at | date:'d/M/yyyy'}}
                        </td>
                        <td>
                            <i *ngIf="userwallet.creditInvoiceFile"   pTooltip="Click to view Invoice PDF" class="bx bxs-file-pdf" style="color: red; font-size: 18px" (click)="downloadPdf(userwallet.creditInvoiceFile)"></i>
                        </td>
                   
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5">No Wallet History.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        In total there are {{totalRecords }} Credit Note History.
                    </div>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>